import { PropsWithChildren } from "react";
import { usePermissionWrapper } from "../../../hooks/usePermissionWrapper";

const PermissionCheck = ({ children, permission }: PropsWithChildren<any>) => {
  const { checkPermission } = usePermissionWrapper();
  return checkPermission(permission) ? children : null;
};

export default PermissionCheck;
